import { defaultIconProps, IconSvgWrapper, type IconProps } from "./base";

const BriefcaseIcon = (props: IconProps) => {
  props = { ...defaultIconProps, ...props };

  return (
    <IconSvgWrapper {...props}>
      <path
        d="M7.875 5.25V3A1.875 1.875 0 0 1 9.75 1.125H13.875A1.875 1.875 0 0 1 15.75 3V5.25H14.625V3A0.75 0.75 0 0 0 13.875 2.25H9.75A0.75 0.75 0 0 0 9 3V5.25Z"
        className={`icon--${props.color}`}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.5 5.25H22.5A1.5 1.5 0 0 1 24 6.75V21.375A1.5 1.5 0 0 1 22.5 22.875H1.5A1.5 1.5 0 0 1 0 21.375V6.75A1.5 1.5 0 0 1 1.5 5.25ZM1.525 6.375A0.4 0.4 0 0 0 1.125 6.775V21.35A0.4 0.4 0 0 0 1.525 21.75H22.475A0.4 0.4 0 0 0 22.875 21.35V6.775A0.4 0.4 0 0 0 22.475 6.375Z"
        className={`icon--${props.color}`}
      />
      <rect x="1.125" y="10.5" width="10.5" height="1.125" className={`icon--${props.color}`} />
      <rect x="12.375" y="10.5" width="10.5" height="1.125" className={`icon--${props.color}`} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 8.25A1.5 1.5 0 0 1 13.5 9.75V12.75A1.5 1.5 0 0 1 10.5 12.75V9.75A1.5 1.5 0 0 1 12 8.25ZM12 9.375A0.375 0.375 0 0 0 11.625 9.75V12.75A0.375 0.375 0 0 0 12.375 12.75V9.75A0.375 0.375 0 0 0 12 9.375Z"
        className={`icon--${props.color}`}
      />
    </IconSvgWrapper>
  );
};

export default BriefcaseIcon;
